import createDrawerProvider from "@/providerFactories/createDrawerProvider";

export const [useLeftDrawer, LeftDrawerProvider, LeftDrawerConsumer] = createDrawerProvider();
export const [useRightDrawer, RightDrawerProvider, RightDrawerConsumer] = createDrawerProvider();
